import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
`
export const StyledButton = styled.button`
  height: 40px;
  width: 40px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  background: #E9E9EA;
  color: #3E3E47;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    border-radius: 4px;
    background: #C9C9CC;
    cursor: auto;

    svg path {
      fill: #7E7E84;
    }
  }

  svg {
    height: 24px;
    width: 24px;
  }

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    height: 48px;
    width: 48px;

    svg {
      height: 28px;
      width: 28px;
    }
  }
`

export const StyledInput = styled.input`
  height: 40px;
  width: 40px;
  margin: 0 4px;
  padding: 0;
  border: 1px solid #D4D4D6;
  text-align: center;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  border-radius: 4px;
  box-sizing: border-box;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    height: 48px;
    width: 48px;
  }
`
